import __vue_normalize__ from '../../../../common/temp/node_modules/.pnpm/registry.npmjs.org/vue-runtime-helpers/1.1.2/node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './TcFieldset.vue_rollup-plugin-vue=script.js';
import './TcFieldset.vue_rollup-plugin-vue=styles.0.css.js';

/* script */
var __vue_script__ = script;
/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tc-fieldset"},[_c('fieldset',[_c('legend',{class:_vm.emptyCaption},[_vm._v("\n      "+_vm._s(_vm.caption)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"tc-fieldset__content"},[(_vm.options)?_c('div',{class:_vm.parentClass},[_vm._l((_vm.options),function(option,index){return [_c(option.component,{key:index,tag:"component",class:option.class,attrs:{"id":(_vm.resolvedId + "_opt_" + index),"variant":option.variant,"value":option.value,"required":_vm.isRequired,"disabled":option.disabled,"inline":_vm.inline,"selectionType":option.selectionType}},[_vm._v("\n            "+_vm._s(option.label)+"\n          ")])]})],2):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('div',{class:_vm.parentClass},[_vm._t("default")],2):_vm._e()])])])};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
